import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { getGame } from "../requests/games"
import { API_Data_Get_Game_Response } from "@/interfaces/api/games/api_request_types"

type UseGameParams = {
  id: string
  locale: string
  profileId?: string | null
}

type GameQueryKey = ['game', string, string, string | null | undefined]

type GameOptions = Omit<
  UseQueryOptions<API_Data_Get_Game_Response, API_Error, API_Data_Get_Game_Response, GameQueryKey>,
  'queryKey' | 'queryFn'
>

export const useGame = ({ id, locale, profileId }: UseGameParams, options?: GameOptions) => 
  useQuery<API_Data_Get_Game_Response, API_Error, API_Data_Get_Game_Response, GameQueryKey>({
    queryKey: ['game', id, locale, profileId],
    queryFn: () => getGame(id, locale, profileId),
    retry: false,
    ...options
  })